import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=02f60180&scoped=true&functional=true"
var script = {}
import style0 from "./activity.vue?vue&type=style&index=0&id=02f60180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "02f60180",
  null
  
)

export default component.exports